import { useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";

// WhatsApp brand SVG (crisp, scalable)
const WhatsAppIcon = ({ className = "" }) => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <path
      fill="currentColor"
      d="M16.003 3C9.373 3 4 8.373 4 15c0 2.117.554 4.106 1.523 5.83L4 27l6.34-1.658A11.94 11.94 0 0 0 16.003 27C22.633 27 28 21.627 28 15S22.633 3 16.003 3zm0 21.6a9.58 9.58 0 0 1-4.882-1.334l-.35-.207-3.762.985 1.006-3.665-.228-.376A9.58 9.58 0 1 1 25.6 15c0 5.298-4.302 9.6-9.597 9.6zm5.5-7.19c-.302-.15-1.79-.881-2.067-.982-.277-.101-.478-.152-.68.152-.201.302-.78.98-.955 1.181-.176.201-.352.226-.653.076-.302-.151-1.274-.469-2.427-1.497-.897-.8-1.503-1.79-1.678-2.091-.176-.302-.019-.464.132-.615.135-.135.302-.352.453-.529.151-.176.201-.302.302-.503.101-.201.05-.377-.025-.529-.076-.151-.68-1.634-.932-2.238-.245-.586-.494-.507-.68-.516l-.577-.01c-.201 0-.529.076-.805.377-.277.302-1.056 1.03-1.056 2.512s1.082 2.914 1.233 3.115c.151.201 2.126 3.243 5.148 4.55.72.312 1.281.498 1.72.638.723.23 1.381.198 1.9.12.58-.087 1.79-.732 2.043-1.438.252-.706.252-1.31.176-1.438-.076-.126-.277-.201-.579-.352z"
    />
  </svg>
);

const COPY = {
  ar: {
    tip: "تواصل معنا عبر واتساب",
    text: "مرحباً ARTLENSS، أودّ الاستفسار عن خدماتكم.",
  },
  en: {
    tip: "Chat with us on WhatsApp",
    text: "Hi ARTLENSS, I'd like to inquire about your services.",
  },
};

const PHONE = "966554142007"; // international format without +

const WhatsAppButton = () => {
  const { lang } = useLang();
  const [mounted, setMounted] = useState(false);
  const c = COPY[lang] || COPY.en;

  useEffect(() => {
    // Reveal after a short delay so it doesn't fight the hero on landing
    const t = setTimeout(() => setMounted(true), 600);
    return () => clearTimeout(t);
  }, []);

  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(c.text)}`;

  return (
    <>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={c.tip}
        data-testid="whatsapp-float-btn"
        className={`group fixed bottom-6 left-6 z-40 flex items-center gap-3 transition-all duration-500 ${
          mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
        }`}
      >
        {/* Tooltip pill — visible on hover / focus */}
        <span
          className="hidden md:inline-block max-w-0 opacity-0 group-hover:max-w-xs group-hover:opacity-100 overflow-hidden whitespace-nowrap transition-[max-width,opacity] duration-500 rounded-full bg-[#0A0A0C]/95 backdrop-blur border border-[#E6A95B]/40 text-white text-sm px-4 py-2.5 shadow-[0_10px_40px_-10px_rgba(230,169,91,0.35)]"
        >
          {c.tip}
        </span>

        {/* Button — WhatsApp green core + amber ring, cinematic glow, gentle pulse */}
        <span className="relative">
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" aria-hidden="true" />
          <span className="relative w-14 h-14 md:w-16 md:h-16 rounded-full grid place-items-center bg-gradient-to-br from-[#25D366] to-[#128C7E] text-white ring-2 ring-[#E6A95B]/60 shadow-[0_10px_50px_-10px_rgba(37,211,102,0.7)] transition-all duration-300 group-hover:ring-[#E6A95B] group-hover:shadow-[0_0_60px_-5px_rgba(37,211,102,0.85)] group-hover:scale-110">
            <WhatsAppIcon className="w-7 h-7 md:w-8 md:h-8" />
          </span>
        </span>
      </a>
    </>
  );
};

export default WhatsAppButton;
